// extracted by mini-css-extract-plugin
export default {"container":"Suggestions__container___u3Eh6","suggestionLabel":"Suggestions__suggestionLabel___cCNv0","listContainer":"Suggestions__listContainer___p1yK7"};